import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { TrackerListView } from '@/features/tracker/TrackerListView'

function Tracker() {
  const { asUser, company } = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  return (
    <TrackerListView
      asUser={asUser}
      companyId={company}
      onCompanyChange={id => navigate({ search: prev => ({ ...prev, company: id || undefined }), replace: true })}
    />
  )
}

export const Route = createFileRoute('/tracker/')({
  // The lens lives in the URL so it is shareable and cannot become a hidden
  // sticky mode a staff member forgets they are in. So does staff's chosen
  // company, so going back from an issue returns to the same list, and a fresh
  // visit starts on no company at all.
  validateSearch: (raw: Record<string, unknown>): { asUser?: string; company?: string } => ({
    asUser: typeof raw.asUser === 'string' && raw.asUser ? raw.asUser : undefined,
    company: typeof raw.company === 'string' && raw.company ? raw.company : undefined,
  }),
  component: Tracker,
})
